import { useEffect } from 'react';
import { Column, Divider, Flex, Heading, Spacer, withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import { useTranslation } from 'react-i18next';
import { ConnectedProps, connect } from 'react-redux';
import translations from 'src/internationalisation/translation-map.json';
import { getCostCodesItems } from 'src/store/entities/cost-codes/cost-codes';
import { selectCostCodesCategories, selectCostCodesItems } from 'src/store/entities/cost-codes/selectors';
import type { TRootState } from 'src/store/store-types';
import { CostCodesTable } from './cost-codes-table';

const CostCodes = ({ getCostCodesItems, costCodesItems, costCodesCategories }: PropsFromRedux) => {
  const { t } = useTranslation();

  useEffect(() => {
    getCostCodesItems();
  }, []);

  return (
    <Column spacing={0}>
      <Spacer height={20} />
      <Flex>
        <Spacer width="var(--padding-sm)" />
        <Heading top>{t(translations.projects_costCodes)}</Heading>
      </Flex>
      <Divider margin={0} />
      <Spacer />
      <Flex gap>
        <Column>
          <CostCodesTable data={costCodesCategories} isCategory={true} t={t} />
        </Column>
        <Column>
          <CostCodesTable data={costCodesItems} t={t} />
        </Column>
      </Flex>
    </Column>
  );
};

const mapStateToProps = (state: TRootState) => ({
  costCodesItems: selectCostCodesItems(state),
  costCodesCategories: selectCostCodesCategories(state),
});

const mapDispatchToProps = {
  getCostCodesItems,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const Container = withErrorBoundary(connector(CostCodes));

export { Container as CostCodes };
